module.exports = "/assets/data/2476d19f3be130c4c8ffa9c0b3bb9b70-CH66.data.json";